import { GeoDsMeta } from './meta-data.model';

export class Resource extends GeoDsMeta {
  Designation?: string;
  Department: string;
  IdRefPerson: string;
  IdRefDepartment: string;
  IdRefDelegationFrom: string;
  ParentId: string;
  Responsibility: string;
  FinishedOn: Date;
  Role: string;
  Interval: number;
  EndDate: Date;
  Member?: string;
  FullName: string;
  constructor(data) {
    super();
    Object.assign(this, data);
  }
}
